import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "35vh",
  paddingBottom: 0,
  borderRadius: "5px",
  display: "block",
  boxShadow: "1px 0px 5px 0px rgba(10, 10, 10, .15)",
  border: "1px solid #ddd",
};

function MapLayoutView({ coordinates }) {
  const mapCenter = {
    lat: coordinates.latitude,
    lng: coordinates.longitude,
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  return isLoaded ? (
    <GoogleMap mapContainerStyle={containerStyle} center={mapCenter} zoom={13}>
      <Marker
        position={mapCenter}
        draggable={false}
        animation={window.google.maps.Animation.DROP}
      />
    </GoogleMap>
  ) : (
    <p className="text-center text-base">
      Učitivanje (Google Maps)...
    </p>
  );
}

export default React.memo(MapLayoutView);
